'use client';

import { type ReactNode, createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

type KlimaMenuContextValue = {
  isOpen: boolean;
  toggle: () => void;
};

const KlimaMenuContext = createContext<KlimaMenuContextValue | null>(null);

export function KlimaMenuProvider({ children }: { children: ReactNode }): React.ReactElement {
  const [isOpen, setOpen] = useState(false);
  const toggle = useCallback((): void => {
    setOpen((o) => !o);
  }, []);

  const value = useMemo((): KlimaMenuContextValue => ({ isOpen, toggle }), [isOpen, toggle]);

  // Sync legacy class (some SCSS and scripts still expect it on the root)
  useEffect((): void => {
    const root = document.getElementById('wirfuersklima-root');
    if (root) {
      root.classList.toggle('navigation--visible', isOpen);
    }
  }, [isOpen]);

  return <KlimaMenuContext.Provider value={value}>{children}</KlimaMenuContext.Provider>;
}

export function useKlimaMenu(): KlimaMenuContextValue {
  const c = useContext(KlimaMenuContext);
  if (!c) {
    throw new Error('useKlimaMenu must be used under KlimaMenuProvider');
  }
  return c;
}
